// The customer's own details, remembered on their device.
//
// AC buyers come back: a second room, a parent's flat, the office. Asking
// them to type the same mobile, name and address again is where a returning
// sale is lost, so checkout saves what they entered and offers it next time.
// Nothing here leaves the browser; it is the same localStorage the cart uses.

const KEY = 'cc_customer_v1';
export const PIN_KEY = 'cc_pincode'; // shared with the product page and cart

const read = (k) => {
  try { return localStorage.getItem(k); } catch { return null; }
};
const write = (k, v) => {
  try { localStorage.setItem(k, v); } catch { /* storage off: nothing remembered */ }
};
const remove = (k) => {
  try { localStorage.removeItem(k); } catch { /* storage off */ }
};

export function loadCustomer() {
  try {
    const c = JSON.parse(read(KEY) || 'null');
    return c && typeof c === 'object' && /^[6-9]\d{9}$/.test(c.mobile || '') ? c : null;
  } catch {
    return null;
  }
}

export function saveCustomer(c) {
  write(KEY, JSON.stringify({ ...c, savedAt: new Date().toISOString() }));
}

export function forgetCustomer() {
  remove(KEY);
}

export function savedPincode() {
  const p = read(PIN_KEY) || '';
  return /^[1-9]\d{5}$/.test(p) ? p : '';
}

export function savePincode(p) {
  if (/^[1-9]\d{5}$/.test(p || '')) write(PIN_KEY, p);
}

export function clearPincode() {
  remove(PIN_KEY);
}

// "2nd floor (lift)"
export function floorText(floor, lift) {
  const f = String(floor ?? '').trim();
  let label = '';
  if (f !== '') {
    const n = Number(f);
    if (n === 0) label = 'Ground floor';
    else if (Number.isFinite(n) && n > 0) {
      const v = n % 100;
      const suffix = v >= 11 && v <= 13 ? 'th' : ({ 1: 'st', 2: 'nd', 3: 'rd' }[n % 10] || 'th');
      label = `${n}${suffix} floor`;
    } else label = `Floor ${f}`;
  }
  const access = lift === 'lift' ? 'lift' : lift === 'nolift' ? 'no lift' : '';
  if (label && access) return `${label} (${access})`;
  return label || (access ? `Building has ${access}` : '');
}
